// Styles
import "./VKbd.css";

// Utilities
import { createSimpleFunctional } from "../../util/index.mjs";
export const VKbd = createSimpleFunctional('v-kbd', 'kbd');
//# sourceMappingURL=index.mjs.map